import { Controller } from "@hotwired/stimulus"
import { showFlash } from "./flash_controller"

export default class extends Controller {
  toggleDefaults(event) {
    const section = document.getElementById("defaults_section")
    if (section) {
      section.classList.toggle("hidden", !event.target.checked)
    }
  }

  submit(event) {
    // Skip if we're in a modal - let the verification controller handle it
    if (this.element.closest('[data-company-verification-target="modal"]')) {
      return
    }

    event.preventDefault()
    event.stopPropagation()
    const form = event.target
    const formData = new FormData(form)

    // Note: Button disabling is handled by submit-protection controller

    fetch(form.action, {
      method: form.method,
      body: formData,
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        // If in modal, close it and refresh the parent form
        const modal = this.element.closest('[data-company-verification-target="modal"]')
        if (modal) {
          const event = new CustomEvent('company:created', { detail: data })
          window.dispatchEvent(event)
          const closeButton = modal.querySelector('[data-action*="company-verification#closeModal"]')
          if (closeButton) closeButton.click()
        } else {
          // Redirect to companies list; Rails flash stored in session will display normally
          window.location.href = '/companies'
        }
      } else {
        // Replace form with errors and reset protection
        this.element.innerHTML = data.html
        // Dispatch event to reset submit protection on the new form
        const newForm = this.element.querySelector('form')
        if (newForm) {
          newForm.dispatchEvent(new Event('submit-protection:reset'))
        }
      }
    })
    .catch(error => {
      console.error("Form submission failed:", error)
      showFlash("Nepavyko išsaugoti įmonės duomenų", "error")
      // Reset submit protection on error
      form.dispatchEvent(new Event('submit-protection:reset'))
    })
  }
}
